import { generateUtilityClasses } from '@mui/material';

type TextInputGhostRootClasses = {
  loading: string;
  overflow: string;
  success: string;
};

export const textInputGhostRootClasses: TextInputGhostRootClasses = generateUtilityClasses(
  'TextInputGhost',
  ['loading', 'success', 'overflow'],
);

// ✅ theme 등록 완전 제거 (styleOverrides, variants가 모두 컴포넌트로 이전됨)
